import {
    doGetQCXRequest,
    doPostQCXRequest,
    doPutQCXActivateRequest,
    doPutQCXInactivateRequest,
    doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';

import { MASTER_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

async function fetchAll(params = []) {
    return doGetQCXRequest([
        MASTER_ENDPOINT,
        "page",
    ],params);
}

async function fetchById(id) {

    console.log(MASTER_ENDPOINT);

    return doGetQCXRequest(
        [
            MASTER_ENDPOINT, 
            id,
        ]
    )
}

async function register(data,queryParams = []) {
    return doPostQCXRequest(
        [MASTER_ENDPOINT],
        data,
        queryParams
    );
}

async function save(data,queryParams = []) {
    return doPutQCXRequest(
        [MASTER_ENDPOINT],
        data,
        queryParams
    );
}

async function activateById(id) {
    return doPutQCXActivateRequest(
        [MASTER_ENDPOINT],
        id
    );
}

async function inactivateById(id) {
    return doPutQCXInactivateRequest(
        [MASTER_ENDPOINT],
        id
    );
}

const aereoAPI = {
    fetchAll,
    fetchById,
    register,
    save,
    activateById,
    inactivateById,
}

export {
    aereoAPI,
    fetchAll,
    fetchById,
    register,
    save,
    activateById,
    inactivateById,
}